import React from 'react'

type Props = {
	children?: React.ReactNode
}

const DatatableHeadRow = ({ children }: Props) => {
	return <div className="hidden lg:table-row min-w-full">{children}</div>
}

export default DatatableHeadRow
